import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'formik';

import './styles.css';
import BasicButton from '../../../../../../components/BasicButton';
import EmailAttachmentRow from './components/EmailAttachmentRow';

const EmailAttachments = props => {
  const {
    attachments,
    name,
    values = [],
    errors = [],
    touched = [],
    onAdd,
    onRemove,
    onRemoveAttach,
    onDownloadAttach,
  } = props;

  const inputFile = useRef();

  const addFile = (e, arrayHelpers) => {
    if (e.target.files && e.target.files.length) {
      onAdd &&
        typeof onAdd === 'function' &&
        onAdd(
          [...e.target.files].map(f => ({ file: f, description: '' })),
          arrayHelpers
        );
      inputFile.current.value = '';
    }
  };

  const handleRemove = (index, arrayHelpers) => {
    onRemove && typeof onRemove === 'function' && onRemove(index, arrayHelpers);
  };

  return (
    <FieldArray
      name={name}
      render={arrayHelpers => (
        <>
          <div className="email-attachments__header">
            <h5 className="form__subtitle">Attachments</h5>
            <div className="email-attachments__button">
              <BasicButton
                controlFunc={() => inputFile.current.click()}
                btnWidth={130}
                btnHeight={35}
                btnFontWeight={500}
                btnArrow={false}
                btnTextColor="#27282d"
                btnText="Add file"
              />
            </div>

            <input
              ref={inputFile}
              multiple
              hidden
              type="file"
              onChange={e => addFile(e, arrayHelpers)}
            />
          </div>

          <div className="email-attachments">
            {attachments &&
              attachments.length > 0 &&
              attachments.map(attach => (
                <Fragment key={attach.id}>
                  <EmailAttachmentRow
                    isValid={true}
                    value={{
                      file: {
                        name: attach.name,
                        size: attach.size,
                      },
                    }}
                    index={Number(attach.id)}
                    onRemove={() => onRemoveAttach(attach.id)}
                    onDownload={onDownloadAttach}
                    uploaded={true}
                  />
                </Fragment>
              ))}

            {values.map((value, index) => {
              const error =
                !!touched[index] && errors[index] ? errors[index] : null;

              return (
                <Fragment key={index}>
                  <EmailAttachmentRow
                    isValid={!error}
                    value={value}
                    index={index}
                    onRemove={index => handleRemove(index, arrayHelpers)}
                    uploaded={false}
                  />
                  {error && (
                    <div className="email-attachments__error">{error}</div>
                  )}
                </Fragment>
              );
            })}
          </div>
        </>
      )}
    />
  );
};

EmailAttachments.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.object.isRequired,
      description: PropTypes.string,
    })
  ),
  attachments: PropTypes.array,
  errors: PropTypes.array,
  touched: PropTypes.array,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onRemoveAttach: PropTypes.func,
  onDownloadAttach: PropTypes.func,
};

export default EmailAttachments;
